import vue from '@/main';
import VueScrollTo from 'vue-scrollto';

import i18n from '~/i18n';

const pushOrScrollTo = (name, scrollTo) =>
    vue.$route.name === name
        ? VueScrollTo.scrollTo(scrollTo)
        : vue.$router.push({ name, query: { scrollTo } });

const actions = () => [
    // { desc: 'Upload profile picture', score: 10, if: (user) => user},
    // { desc: 'Add skills', score: 10 },
    // { desc: 'Upload CV', score: 10 },
    // { desc: 'Write a summary', score: 5 },
    {
        desc: i18n.t(
            'components.smart.profileModule.profileActions.addFirstName'
        ),
        score: 10,
        if: user => !user.firstName,
        action: () => pushOrScrollTo('spotlight', '#personal'),
    },
    {
        desc: i18n.t(
            'components.smart.profileModule.profileActions.addLastName'
        ),
        score: 10,
        if: user => !user.lastName,
        action: () => pushOrScrollTo('spotlight', '#personal'),
    },
    {
        desc: i18n.t(
            'components.smart.profileModule.profileActions.addNationality'
        ),
        score: 10,
        if: user => !user.nationality,
        action: () => pushOrScrollTo('spotlight', '#personal'),
    },
    {
        desc: i18n.t('components.smart.profileModule.profileActions.addGender'),
        score: 5,
        if: user => !user.gender || user.gender === 'U',
        action: () => pushOrScrollTo('spotlight', '#personal'),
    },
    {
        desc: i18n.t(
            'components.smart.profileModule.profileActions.addPhoneNumber'
        ),
        score: 20,
        if: user => !user.phoneNumber,
        action: () => pushOrScrollTo('spotlight', '#contact'),
    },
    {
        desc: i18n.t(
            'components.smart.profileModule.profileActions.addLanguage'
        ),
        score: 15,
        if: (_, profile) => profile.languages.length == 0,
        action: () => pushOrScrollTo('spotlight', '#language'),
    },
    {
        desc: i18n.t(
            'components.smart.profileModule.profileActions.addEducation'
        ),
        score: 15,
        if: (_, profile) =>
            !Boolean(profile && profile.degrees && profile.degrees.length > 0),
        action: () => pushOrScrollTo('spotlight', '#education'),
    },
    {
        desc: i18n.t('components.smart.profileModule.profileActions.addEmail'),
        score: 15,
        if: user => !user.email,
        action: () => pushOrScrollTo('spotlight', '#contact'),
    },
];

export const maxPossibleScore = actions().reduce(
    (acc, val) => acc + val.score,
    0
);

export const getCurrentScore = (user, profile) => {
    return actions().reduce(
        (acc, val) => acc + (!val.if(user, profile) ? val.score : 0),
        0
    );
};

export default function(user, profile) {
    if (user instanceof Array || profile instanceof Array) return [];
    return actions().filter(it => it.if(user, profile));
}
